export default "__VITE_ASSET__Y4kqqEip__"